/**
 * HUD Wave Cards — prep-phase hint only.
 * Current/next wave info lives in the top-bar (see top-bar.ts).
 */

import type { GameStateView } from "../../application/ports.js";
import { t } from "../../i18n/index.js";

export function createWaveCards(parent: HTMLElement): {
  update(state: GameStateView): void;
} {
  // Prep-phase hint (shown centered when speed === 0)
  const prepHint = document.createElement("div");
  prepHint.className = "hud-prep-hint";
  prepHint.style.display = "none";
  const prepHintText = document.createElement("span");
  prepHintText.className = "hud-prep-hint__text";
  prepHint.appendChild(prepHintText);

  parent.appendChild(prepHint);

  let _lastSpeed: number | undefined;
  let _lastKey: string | undefined;

  return {
    update(state: GameStateView): void {
      const speed = state.speed;
      if (speed !== _lastSpeed) {
        _lastSpeed = speed;
        prepHint.style.display = (speed === 0 && state.won === null) ? "" : "none";
      }

      // Before first wave with no relic in any chapel → prompt to create a relic.
      const isPreBattle =
        (state.currentWaveIndex ?? 0) === 0 && (state.monsters?.length ?? 0) === 0;
      const hasGemInTower =
        state.towers?.some((t) => t.gemSlots?.some((s) => s.gem)) ?? false;
      const key = isPreBattle && !hasGemInTower ? "tutorial.firstGem" : "hud.prepSpace";
      if (key !== _lastKey) {
        _lastKey = key;
        prepHintText.textContent = t(key);
      }
    },
  };
}
